// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2S75U","label":"Completed_label__3bs7x"};